export function generateUUID() {
	let d = new Date().getTime();

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		var r = (d + Math.random()*16)%16 | 0;
		d = Math.floor(d/16);
		return (c =='x' ? r : (r&0x3|0x8)).toString(16);
	});
}

export function isUUID(value) {
	const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return regex.test(value);
}